import React from 'react';
import { Shield, Award, CheckCircle, Scale } from 'lucide-react';

const TrustSection = () => {
  const trustItems = [
    {
      icon: Scale,
      title: 'Atuação via CDC',
      description: 'Código de Defesa do Consumidor'
    },
    {
      icon: Shield,
      title: 'Sigilo Garantido',
      description: 'Seus dados protegidos'
    },
    {
      icon: Award,
      title: 'Equipe Especializada',
      description: 'Advogados e peritos técnicos'
    },
    {
      icon: CheckCircle,
      title: 'Atendimento Nacional',
      description: '100% digital'
    }
  ];

  return (
    <section className="py-12 bg-white border-y border-slate-100">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex flex-col md:flex-row items-center justify-center gap-8 md:gap-16">
          {trustItems.map((item, index) => (
            <div key={index} className="flex items-center gap-3 group">
              <div className="w-12 h-12 bg-slate-50 rounded-xl flex items-center justify-center group-hover:bg-emerald-50 transition-colors duration-300">
                <item.icon className="w-6 h-6 text-slate-600 group-hover:text-emerald-600 transition-colors duration-300" />
              </div>
              <div>
                <p className="font-semibold text-slate-800">{item.title}</p>
                <p className="text-sm text-slate-500">{item.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default TrustSection;
